import React, { memo, useEffect, useRef, useState } from 'react';
import { isEmpty, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import qs from 'qs';
import { useTbodyPosition } from '../../../../utils/hooks/useTbodyPosition';
import TableEmptySearch from '../../../../components/Table/EmptySearch';
import EmptyTable from '../../../../components/Table/TableEmpty';

const TableBody = ({
  orders,
  isTableLoading,
  children,
}) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: orders?.length, bodyHeight: '300px' });
  const [firstLoading, setFirstLoading] = useState(false)
  const queryString = qs.parse(window.location.search.slice(1));

  useEffect(() => {
    if (!firstLoading && !isTableLoading) {
      setFirstLoading(true)
    }
  }, [firstLoading, isTableLoading])

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isTableLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: position.x }}
      ref={bodyRef}
    >
      {orders.length ? children : firstLoading ? isEmpty(queryString) ? <EmptyTable /> : <TableEmptySearch search={queryString?.query} /> : null}
    </tbody>
  );
};

TableBody.propTypes = {
  orders: PropTypes.array,
  isTableLoading: PropTypes.bool,
  children: PropTypes.object,
};

const areEqual = (prevProps, nextProps) => isEqual(prevProps.isTableLoading, nextProps.isTableLoading)
  && isEqual(prevProps.values, nextProps.values);

export default memo(TableBody, areEqual);
